import React, { Suspense, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, Link, Route, Routes, Navigate } from 'react-router-dom'
import { getOneRosterSchoolUnit } from '../../../store/OneRoster/OneRosterSchoolUnitAction';
import StatusCode from '../../../util/StatusCode';
import * as Tab from '../../../util/TabValue';
import RenderTabs from '../../misc/Tabs';
import { OneRosterSchoolUnit } from '../../../models/CoreOneRosterModels';
import { RequestState } from '../../../models/RequestState';
import NotFound from '../../administration/components/NotFound';
import Loading from '../../misc/Loading';
import { useTranslation } from 'react-i18next';
import OneRosterSchoolUnitInfo from './OneRosterSchoolUnitInfo';
import { RootState } from '../../../store/store';


const OneRosterSchoolUnitView = () => {
    const { t } = useTranslation(['common', 'oneRoster']);

    const { schoolId } = useParams();
    const dispatch = useDispatch();
    const school = useSelector<RootState, RequestState<OneRosterSchoolUnit>>(state => state.onerosterSchoolunit.schoolUnit);

    useEffect(() => {
        if (schoolId !== undefined) {
            getOneRosterSchoolUnit(schoolId)(dispatch);
        }
    }, [dispatch, schoolId]);

    const tabs = [
        Tab.Tabs.Information,
    ];

    if (schoolId === undefined) {
        return;
    }

    const renderContent = (body: any) => (
        <div className="padding-40 container single">
            <h1><Link to="/oneroster/schoolunit">{t('object.oneRoster.school', { ns: 'common', count: 1 })}</Link> {displayName}</h1>
            {body}
        </div>
    )

    let displayName: string | undefined = '';

    switch (school.code) {
        case StatusCode.COMPLETE:
            displayName = school.data.name;
            return (renderContent(<>
                <RenderTabs
                    tabs={tabs}
                    id={schoolId}
                    url="oneroster/schoolunit" />

                <Suspense>
                    <Routes>
                        <Route path={Tab.Tabs.Information.url} element={<OneRosterSchoolUnitInfo />} />
                        <Route path="*" element={<Navigate replace={true} to={`/oneroster/schoolunit/${schoolId}/${Tab.Tabs.Information.url}`} />} />
                    </Routes>
                </Suspense>
            </>));
        case StatusCode.ERROR:
            if (school.error.response?.status === 404 || school.error.response?.status === 400) {
                return (
                    <NotFound
                        header={t('object.oneRoster.school', { ns: 'common', count: 1 })}
                        translateKey={{ i18nKey: "notFound.school", ns: "oneRoster" }}
                        link="/oneroster/schoolunit"
                    />
                );
            } else {
                return renderContent(<p>{school.error.response?.statusText}</p>);
            }
        default:
            return (renderContent(<Loading />));
    }

}
export default OneRosterSchoolUnitView;
